export default __webpack_public_path__ + "static/media/image-near-it.0f3b4122.png";